@if (show) {
    <ng-container>
        <mat-progress-bar
            [mode]="mode"
            [value]="progress"></mat-progress-bar>
    </ng-container>
}
